import { useRef, useState, useEffect, useMemo } from 'react';
import { apiHolder as api, apis, apiHolder, getIn18Text, } from 'api';
import { formatReadStatus } from '@web-mail/util';
import lodashGet from 'lodash/get';
import useDebounceForEvent from '@web-common/hooks/useDebounceForEvent';
import { FLOLDER } from '@web-mail/common/constant';
import useMsgRenderCallback from '@web-common/hooks/useMsgRenderCallback';
import { isThirdSendFn } from '@web-mail/components/OpenRecords/OpenRecords';
import moment from 'moment';
const systemApi = api.api.getSystemApi();
const mailManagerApi = api.api.requireLogicalApi(apis.mailConfApiImpl);
const htmlApi = apiHolder.api.requireLogicalApi(apis.htmlApi);
const eventApi = api.api.getEventApi();
const mailApi = api.api.requireLogicalApi(apis.mailApiImpl);
const accountApi = api.api.requireLogicalApi(apis.accountApiImpl);
const storeApi = api.api.getDataStoreApi();
const productAuthApi = api.api.requireLogicalApi(apis.productAuthApiImpl);
const useGetReadStatus = (content) => {
    const [openRecordData, setOpenRecordData] = useState();
    const [readStatus, setReadStatus] = useState();
    const [rclStatus, setRclStatus] = useState();
    const [readOnlyStatus, setReadOnlyStatus] = useState();
    const entryStats = useMemo(() => {
        if (!(content === null || content === void 0 ? void 0 : content.entry)) {
            return {
                rcptCount: 0,
                readCount: 0,
                innerCount: 0,
                innerRead: 0,
                openCount: 0,
            };
        }
        const obj = content.entry;
        return {
            rcptCount: (obj === null || obj === void 0 ? void 0 : obj.rcptCount) || 0,
            readCount: (obj === null || obj === void 0 ? void 0 : obj.readCount) || 0,
            innerCount: (obj === null || obj === void 0 ? void 0 : obj.innerCount) || 0,
            innerRead: (obj === null || obj === void 0 ? void 0 : obj.innerRead) || 0,
            openCount: (obj === null || obj === void 0 ? void 0 : obj.openCount) || 0,
        };
    }, [content === null || content === void 0 ? void 0 : content.entry]);
    const prevEntryStatsRef = useRef(entryStats);
    useEffect(() => {
        if (!content) {
            return;
        }
        const prevStats = prevEntryStatsRef.current;
        const currentStats = entryStats;
        const hasChanged = prevStats.rcptCount !== currentStats.rcptCount ||
            prevStats.readCount !== currentStats.readCount ||
            prevStats.innerCount !== currentStats.innerCount ||
            prevStats.innerRead !== currentStats.innerRead ||
            prevStats.openCount !== currentStats.openCount;
        if (hasChanged) {
            prevEntryStatsRef.current = currentStats;
            getReadStatus(content);
        }
    }, [entryStats, content]);
    const formatReadStatusByProduct = (list) => {
        const listData = formatReadStatus(list);
        const versionId = productAuthApi.doGetProductVersionId();
        if (versionId === 'sirius') {
            const stateTrack = storeApi.getSync('stateTrack').data;
            const domainList = lodashGet(systemApi.getCurrentUser(), 'prop.domainList', []);
            if (stateTrack === 'OFF') {
                listData.data = (listData.data || []).map((listItem) => {
                    const item = Object.assign({}, listItem);
                    const { email } = item;
                    if (email) {
                        const suffix = email.split('@')[1];
                        if (suffix && !domainList.includes(suffix)) {
                            item.status = 'outdomain';
                            item.text = getIn18Text('EMAIL_READ_STATUS_SERVER_RECEIVE');
                            item.color = '';
                        }
                    }
                    return item;
                });
            }
            if (content && !!isThirdSendFn(content)) {
                listData.data = (listData.data || []).map((listItem) => {
                    const item = Object.assign({}, listItem);
                    const { email } = item;
                    if (email) {
                        const suffix = email.split('@')[1];
                        if (suffix && !domainList.includes(suffix)) {
                            item.status = 'outdomain';
                            item.text = getIn18Text('ZHIYOUZAIWMTFCDYJCKZ19');
                            item.color = '#F74F4F';
                        }
                    }
                    return item;
                });
            }
            return listData;
        }
        if (versionId === 'free') {
            if (listData.data) {
                listData.data.forEach(item => {
                    item.status = 'unkown';
                    if (item.result === 109) {
                        item.text = getIn18Text('EMAIL_READ_STATUS_SERVER_RECEIVE');
                    }
                    item.color = '';
                });
            }
        }
        else {
            if (listData.data) {
                listData.data.forEach(item => {
                    if (!(item === null || item === void 0 ? void 0 : item.inner)) {
                        item.status = 'unkown';
                        if (item.result === 109) {
                            item.text = getIn18Text('EMAIL_READ_STATUS_SERVER_RECEIVE');
                        }
                        item.color = '';
                    }
                });
            }
        }
        return listData;
    };
    const getMailReadCount = async (content) => {
        const { id, entry, sender } = content || {};
        const { tid } = entry;
        try {
            const res = await mailApi.doGetMailReadCount({
                mid: id,
                tid,
                fromEmail: sender.contact.contact.accountName,
                _account: content === null || content === void 0 ? void 0 : content._account,
            });
            console.log('getMailReadCount', res);
            const { code, data, message } = res;
            if (code === 0) {
                if (data.count === 1) {
                    getMailReadDetail(content);
                }
                else {
                    setOpenRecordData({
                        count: data.count || 0,
                        records: [],
                    });
                }
                return;
            }
            console.log('doGetMailReadCount fail', message);
            setOpenRecordData({ count: 0, records: [] });
        }
        catch (error) {
            console.log('doGetMailReadCount error', error);
            setOpenRecordData({ count: 0, records: [] });
        }
    };
    const getMailReadDetail = async (content) => {
        const { id, entry, sender } = content || {};
        const { tid } = entry;
        try {
            const res = await mailApi.doGetMailReadDetail({
                mid: id,
                tid,
                fromEmail: sender.contact.contact.accountName,
                _account: content === null || content === void 0 ? void 0 : content._account,
            });
            console.log('getMailReadDetail', res);
            const { code, data, message } = res;
            if (code === 0) {
                const systemTimeZone = systemApi.getSystemTimeZone();
                if (systemTimeZone) {
                    const records = data.readList || [];
                    const dealedRecords = [];
                    const now = moment();
                    records.forEach((item) => {
                        let settingTime = '';
                        if (item.currentLocalTime) {
                            const settingMoment = systemApi.timeZoneTrans(item.currentLocalTime, 8, systemTimeZone.key);
                            if (now.year() === (settingMoment === null || settingMoment === void 0 ? void 0 : settingMoment.year())) {
                                settingTime = (settingMoment === null || settingMoment === void 0 ? void 0 : settingMoment.format('MM-DD HH:mm')) || '';
                                item.remoteLocalTime = item.remoteLocalTime ? moment(item.remoteLocalTime).format('MM-DD HH:mm') || '' : '';
                            }
                            else {
                                settingTime = (settingMoment === null || settingMoment === void 0 ? void 0 : settingMoment.format('YYYY-MM-DD HH:mm')) || '';
                            }
                        }
                        dealedRecords.push(Object.assign(Object.assign({}, item), { settingTime, settingTimeZone: systemTimeZone === null || systemTimeZone === void 0 ? void 0 : systemTimeZone.value }));
                    });
                    setOpenRecordData({
                        count: dealedRecords.length,
                        records: dealedRecords,
                    });
                    return;
                }
            }
            console.log('doGetMailReadDetail fail', message);
            setOpenRecordData({ count: 0, records: [] });
        }
        catch (error) {
            console.log('doGetMailReadDetail error', error);
            setOpenRecordData({ count: 0, records: [] });
        }
    };
    const getReadStatus = async (content) => {
        var _a, _b;
        try {
            const currentUser = systemApi.getCurrentUser(content === null || content === void 0 ? void 0 : content._account);
            const accountAlias = ((_a = currentUser === null || currentUser === void 0 ? void 0 : currentUser.prop) === null || _a === void 0 ? void 0 : _a.accountAlias) || [];
            const accountAliasArray = Array.isArray(accountAlias) ? accountAlias : [accountAlias];
            const sender = content === null || content === void 0 ? void 0 : content.sender;
            const isMySend = accountAliasArray.some(item => {
                var _a, _b;
                return accountApi.getIsSameSubAccountSync(item, (_b = (_a = sender === null || sender === void 0 ? void 0 : sender.contact) === null || _a === void 0 ? void 0 : _a.contact) === null || _b === void 0 ? void 0 : _b.accountName);
            });
            let emailId = content.id;
            if (isMySend) {
                emailId = ((_b = content === null || content === void 0 ? void 0 : content.entry) === null || _b === void 0 ? void 0 : _b.sentMailId) || content.id;
            }
            const readStatusData = await mailApi.doCheckReadStatus(emailId, content === null || content === void 0 ? void 0 : content._account);
            const allDetail = readStatusData.detail;
            const formattedCombined = formatReadStatusByProduct(allDetail);
            setReadStatus(formattedCombined);
            const rclItems = allDetail.filter(d => d.result >= 700);
            setRclStatus(rclItems.length > 0 ? formatReadStatusByProduct(rclItems) : undefined);
            const externalItems = readStatusData.externalDetail;
            if (externalItems && externalItems.length > 0) {
                const convertedReadItems = externalItems.map(ext => ({
                    email: ext.to,
                    result: ext.read ? 109 : 100,
                    rclResult: 0,
                    contactName: ext.to,
                    modifiedTime: ext.readTime ? new Date(ext.readTime).toISOString().slice(0, 19).replace('T', ' ') : '',
                    mid: emailId,
                    inner: ext.inner,
                }));
                setReadOnlyStatus(formatReadStatusByProduct(convertedReadItems));
            }
            else {
                const readItems = allDetail.filter(d => d.result < 700);
                setReadOnlyStatus(readItems.length > 0 ? formatReadStatusByProduct(readItems) : undefined);
            }
        }
        catch (error) {
            console.error(`获取邮件阅读状态失败：${error}`);
        }
    };
    const getStatusOrDetail = (content) => {
        var _a, _b, _c, _d, _e, _f;
        if (!content)
            return;
        const { isTpMail, authAccountType } = content || {};
        const accountAlias = ((_b = (_a = systemApi.getCurrentUser(content === null || content === void 0 ? void 0 : content._account)) === null || _a === void 0 ? void 0 : _a.prop) === null || _b === void 0 ? void 0 : _b.accountAlias) || [];
        const accountAliasArray = Array.isArray(accountAlias) ? accountAlias : [accountAlias];
        const senderEmail = ((_e = (_d = (_c = content === null || content === void 0 ? void 0 : content.sender) === null || _c === void 0 ? void 0 : _c.contact) === null || _d === void 0 ? void 0 : _d.contact) === null || _e === void 0 ? void 0 : _e.accountName) || '';
        const isSend = ((_f = content === null || content === void 0 ? void 0 : content.entry) === null || _f === void 0 ? void 0 : _f.folder) === FLOLDER.SENT ||
            accountAliasArray.some(account => accountApi.getIsSameSubAccountSync(account, senderEmail)) ||
            accountApi.getIsSameSubAccountSync(senderEmail, content._account);
        if (isSend && !isTpMail) {
            if (authAccountType && authAccountType !== '0') {
                getMailReadCount(content);
                return;
            }
            getReadStatus(content);
        }
    };
    const debounceGetStatusOrDetail = useDebounceForEvent((content) => {
        if (!content)
            return;
        getStatusOrDetail(content);
    }, 500);
    useMsgRenderCallback('mailMenuOper', ev => {
        if ((ev === null || ev === void 0 ? void 0 : ev.eventStrData) === 'retractEmailSuccess' && content) {
            const { id } = ev.eventData;
            if (id === (content === null || content === void 0 ? void 0 : content.id)) {
                debounceGetStatusOrDetail(content);
            }
        }
    });
    return {
        openRecordData,
        setOpenRecordData,
        readStatus,
        setReadStatus,
        rclStatus,
        readOnlyStatus,
        debounceGetStatusOrDetail,
        getStatusOrDetail,
        formatReadStatusByProduct,
        getMailReadDetail,
    };
};
export default useGetReadStatus;
